export const UNDEFINED_PART = '- Undefined Part -';
